import { Center, Flex, Text } from "@chakra-ui/react";
import { IS_CONTRACT_UPGRADE_IN_PROGRESS } from "@constants/upgradeFlags";

const UpgradeBanner = () => {
  if (!IS_CONTRACT_UPGRADE_IN_PROGRESS) {
    return null;
  }

  return (
    <Center
      w="100%"
      bg="#F59E0B"
      fontSize={{ base: "12px", md: "14px" }}
      pos="relative"
      top="0"
      zIndex={7}
      p="10px"
      px={{ base: "16px", lg: "68px" }}
    >
      <Flex
        color="#1F2937"
        fontWeight="500"
        lineHeight="140%"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        gap={{ base: "8px", md: "12px" }}
        w="100%"
      >
        <Text fontWeight="600">
          Scheduled Maintenance: Some features may be temporarily unavailable.
          Thank you for your patience.
        </Text>
      </Flex>
    </Center>
  );
};

export default UpgradeBanner;
